exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containerVideo[data-v-9364128a]{--vSize:100%;position:relative;margin:0}.containerVideo[data-v-9364128a],video[data-v-9364128a]{height:var(--vSize);-o-object-fit:cover;object-fit:cover}video[data-v-9364128a]{width:auto;aspect-ratio:16/9;position:absolute;top:0;right:0;z-index:0}@-webkit-keyframes fadeIn-data-v-9364128a{0%{opacity:0}to{opacity:1}}@keyframes fadeIn-data-v-9364128a{0%{opacity:0}to{opacity:1}}.active[data-v-9364128a]{-webkit-animation:fadeIn-data-v-9364128a .5s ease-in-out;animation:fadeIn-data-v-9364128a .5s ease-in-out}.fade-enter-active[data-v-9364128a],.fade-leave-active[data-v-9364128a]{-webkit-transition:opacity .5s ease;transition:opacity .5s ease}.fade-enter-from[data-v-9364128a],.fade-leave-to[data-v-9364128a]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9364128a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/VideoTogglePlayer.vue
// module id = edW0
// module chunks = 4